import { render, staticRenderFns } from "./synonyms-list.view.vue?vue&type=template&id=1b01da74"
import script from "./synonyms-list.view.vue?vue&type=script&lang=ts"
export * from "./synonyms-list.view.vue?vue&type=script&lang=ts"
import style0 from "./synonyms-list.view.vue?vue&type=style&index=0&id=1b01da74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports